import { Box, Typography, Grid } from '@mui/material';
import { keyframes } from '@mui/system';

const countUp = keyframes`
  from { opacity:0; transform:translateY(20px); }
  to   { opacity:1; transform:translateY(0); }
`;

const stats = [
  { value: '2 400+', label: 'Joueurs Suivis' },
  { value: '180+',   label: 'Tournois Gérés' },
  { value: '95 %',   label: 'Satisfaction Clubs' },
  { value: '12',     label: 'Pays Couverts' },
];

const StatsBar = () => (
  <Box sx={{
    bgcolor: '#f0fdf4',
    py: 6,
    borderTop: '1px solid rgba(34,197,94,.15)',
    borderBottom: '1px solid rgba(34,197,94,.15)',
  }}>
    <Grid container justifyContent="center" spacing={2}>
      {stats.map((s, i) => (
        <Grid item xs={6} md={3} key={i} sx={{
          textAlign: 'center',
          animation: `${countUp} .8s ease forwards`,
          animationDelay: `${i * .15}s`,
          opacity: 0,
        }}>
          <Typography variant="h3" sx={{
            fontWeight: 900,
            fontSize: { xs: '2rem', md: '2.8rem' },
            background: 'linear-gradient(135deg, #16a34a, #22c55e)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>
            {s.value}
          </Typography>
          <Typography variant="body2" sx={{
            color: '#94a3b8',
            mt: .5,
            textTransform: 'uppercase',
            letterSpacing: 1.5,
            fontSize: '.75rem',
          }}>
            {s.label}
          </Typography>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default StatsBar;